import {useContext, useEffect, useRef} from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import './Chart.scss';
import {authContext} from "../../Context/Authentication/authContext";

am4core.addLicense('CH332271218');

am4core.useTheme(am4themes_animated);

const Chart = ({chartData, title, chartId, isMulti, isPredition, isSetToZoom}: any) => {
  const chartRef: any = useRef(null);
  const {state, dispatch}: any = useContext(authContext);
  console.log(chartData)

  useEffect(() => {
    chartRef.current = am4core.create(chartId, am4charts.XYChart);
    const chartTitle = chartRef.current.titles.create();
    chartTitle.text = title
    chartTitle.fontSize = 25;
    chartTitle.marginBottom = 10;

    chartRef.current.data = chartData;
    chartRef.current.dateFormatter.inputDateFormat = 'MM-dd-yyyy';

    let scrollbarX = new am4charts.XYChartScrollbar();
    if (isSetToZoom) {
      scrollbarX.background.fill = am4core.color('#fff');
      scrollbarX.background.fillOpacity = 0.2;
      scrollbarX.startGrip.icon.stroke = am4core.color('#fff');
      scrollbarX.endGrip.icon.stroke = am4core.color('#fff');
      chartRef.current.events.on('ready', function () {
        if (state.filters.chartStartDate && state.filters.chartEndDate) {
          dateAxis.zoomToDates(
            new Date(state.filters.chartStartDate),
            new Date(state.filters.chartEndDate)
          );
        }
      });
    }


    const dateAxis = chartRef.current.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.strokeWidth = 1;
    dateAxis.renderer.grid.template.strokeOpacity = 0.3;
    dateAxis.renderer.grid.template.stroke = '#fff';
    dateAxis.renderer.minGridDistance = 100;
    dateAxis.renderer.labels.template.fontSize = 10;
    dateAxis.title.fontWeight = 'bold';
    dateAxis.dateFormats.setKey('month', 'MMM YY');
    dateAxis.renderer.labels.template.fill = '#fff';

    const dateAxisChanged = (ev: any) => {
      let start = ev.target.minZoomed;
      let end = ev.target.maxZoomed;
      dispatch({
        type: 'APPLY_FILTER',
        payload: {
          ...state.filters,
          chartStartDate: start,
          chartEndDate: end,
        },
      });
    }
    dateAxis.events.on('startchanged', dateAxisChanged);
    dateAxis.events.on('endchanged', dateAxisChanged);

    const valueAxis = chartRef.current.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.grid.template.stroke = '#fff';
    valueAxis.renderer.grid.template.strokeWidth = 1;
    valueAxis.renderer.grid.template.strokeOpacity = 0.3;
    valueAxis.title.fontWeight = 'bold';
    valueAxis.renderer.labels.template.fontSize = 10;
    valueAxis.renderer.labels.template.fill = '#fff';

    const currentDate = new Date()
    const year = currentDate.getFullYear()
    const month = currentDate.getMonth() - 2
    let predictionDate = new Date(year, month, 1)

    if (isMulti) {
      console.log(state.filters)

      if(state.filters.selectedType ==='whatIfMulti' || state.filters.selectedType ==='whatIfMultiMSA' ){
        const series2 = chartRef.current.series.push(new am4charts.LineSeries());
        series2.dataFields.dateX = 'date';
        series2.dataFields.valueY = isPredition ? 'adjusted_prediction' : 'adjusted_predictions';
        series2.strokeWidth = 2;
        series2.name = 'Adjusted Prediction After Impact';
        series2.tooltipHTML = `<div class="tooltip-whatif">{name}: {valueY} <br/> Date: {dateX.formatDate('MM-dd-yyyy')}</div>`
        series2.stroke = '#A010C7';
        series2.fill = '#A010C7';
  
        const hs2 = series2.segments.template.states.create('hover')
        hs2.properties.strokeWidth = 5;
        hs2.properties.fill = '#fff';
        series2.segments.template.strokeWidth = 1;
  
        if (isSetToZoom) {
          const bullet2 = series2.bullets.push(new am4charts.CircleBullet());
          bullet2.circle.strokeWidth = 1;
          bullet2.circle.radius = 3;
          const range2 = dateAxis.createSeriesRange(series2);
          try {
            // @ts-ignore
            if (state.filters.selectedType === 'predictedMetrics') predictionDate = predictionTill?.city || predictionDate
            // @ts-ignore
            else predictionDate = predictionTill?.zip || predictionDate
          } catch (e) {
            console.error(e)
          }
  
          range2.date = predictionDate
          range2.endDate = new Date(2029, 4, 1);
          range2.contents.strokeDasharray = '3, 3';
        }
        
      }
      else{
        state.filters.predictionsArray.map((t:string)=>{
          if(t==='Mortgage Rates'){
            const series2 = chartRef.current.series.push(new am4charts.LineSeries());
        series2.dataFields.dateX = 'date';
        series2.dataFields.valueY = isPredition ? 'adjusted_prediction' : 'adjusted_predictions';
        series2.strokeWidth = 2;
        series2.name = 'Prediction for anticipated MR';
        series2.tooltipHTML = `<div class="tooltip-whatif">{name}: {valueY} </div>`
        series2.stroke = '#A010C7';
        series2.fill = '#A010C7';
  
        const hs2 = series2.segments.template.states.create('hover')
        hs2.properties.strokeWidth = 5;
        hs2.properties.fill = '#fff';
        series2.segments.template.strokeWidth = 1;
  
        if (isSetToZoom) {
          const bullet2 = series2.bullets.push(new am4charts.CircleBullet());
          bullet2.circle.strokeWidth = 1;
          bullet2.circle.radius = 3;
          const range2 = dateAxis.createSeriesRange(series2);
          try {
            // @ts-ignore
            if (state.filters.selectedType === 'predictedMetrics') predictionDate = predictionTill?.city || predictionDate
            // @ts-ignore
            else predictionDate = predictionTill?.zip || predictionDate
          } catch (e) {
            console.error(e)
          }
  
          range2.date = predictionDate
          range2.endDate = new Date(2029, 4, 1);
          range2.contents.strokeDasharray = '3, 3';
        }
  
          }
          else if(t === 'Consumer Sentiments(HPSI)'){
            const series3 = chartRef.current.series.push(new am4charts.LineSeries());
        series3.dataFields.dateX = 'date';
        series3.dataFields.valueY = isPredition ? 'consumer_adjusted_prediction' : 'consumer_adjusted_predictions';
        series3.strokeWidth = 2;
        series3.name = 'Prediction for anticipated HPSI';
        series3.tooltipHTML = `<div class="tooltip-whatif">{name}: {valueY} </div>`
        series3.stroke = '#FF0000';
        series3.fill = '#FF0000';
  
        const hs2 = series3.segments.template.states.create('hover')
        hs2.properties.strokeWidth = 5;
        hs2.properties.fill = '#fff';
        series3.segments.template.strokeWidth = 1;
  
        if (isSetToZoom) {
          const bullet2 = series3.bullets.push(new am4charts.CircleBullet());
          bullet2.circle.strokeWidth = 1;
          bullet2.circle.radius = 3;
          const range2 = dateAxis.createSeriesRange(series3);
          try {
            // @ts-ignore
            if (state.filters.selectedType === 'predictedMetrics') predictionDate = predictionTill?.city || predictionDate
            // @ts-ignore
            else predictionDate = predictionTill?.zip || predictionDate
          } catch (e) {
            console.error(e)
          }
  
          range2.date = predictionDate
          range2.endDate = new Date(2029, 4, 1);
          range2.contents.strokeDasharray = '3, 3';
        }
  
          }
          else if(t === 'Builder Sentiments(NAHB)'){
            const series4 = chartRef.current.series.push(new am4charts.LineSeries());
        series4.dataFields.dateX = 'date';
        series4.dataFields.valueY = isPredition ? 'builder_adjusted_prediction' : 'builder_adjusted_predictions';
        series4.strokeWidth = 2;
        series4.name = 'Prediction for anticipated NAHB';
        series4.tooltipHTML = `<div class="tooltip-whatif">{name}: {valueY} </div>`
        series4.stroke = '#ADD8E6';
        series4.fill = '#ADD8E6';
  
        const hs2 = series4.segments.template.states.create('hover')
        hs2.properties.strokeWidth = 5;
        hs2.properties.fill = '#fff';
        series4.segments.template.strokeWidth = 1;
  
        if (isSetToZoom) {
          const bullet2 = series4.bullets.push(new am4charts.CircleBullet());
          bullet2.circle.strokeWidth = 1;
          bullet2.circle.radius = 3;
          const range2 = dateAxis.createSeriesRange(series4);
          try {
            // @ts-ignore
            if (state.filters.selectedType === 'predictedMetrics') predictionDate = predictionTill?.city || predictionDate
            // @ts-ignore
            else predictionDate = predictionTill?.zip || predictionDate
          } catch (e) {
            console.error(e)
          }
  
          range2.date = predictionDate
          range2.endDate = new Date(2029, 4, 1);
          range2.contents.strokeDasharray = '3, 3';
        }
  
          }
        })

      }

      
      
    }

    const series = chartRef.current.series.push(new am4charts.LineSeries());
    series.dataFields.dateX = 'date';
    series.dataFields.valueY = 'actual_predictions';
    series.strokeWidth = 2;
    series.name = 'Actual Prediction';
    series.tooltipHTML = `<div class="tooltip-whatif">{name}: {valueY} <br/> Date: {dateX.formatDate('MM-dd-yyyy')}</div>`
    series.stroke = '#f7b047';
    series.fill = '#f7b047';
    let hs1 = series.segments.template.states.create('hover')
    hs1.properties.strokeWidth = 5;
    hs1.properties.fill = '#fff';
    series.segments.template.strokeWidth = 1;

    if (isSetToZoom) {
      const bullet1 = series.bullets.push(new am4charts.CircleBullet());
      bullet1.circle.strokeWidth = 1;
      bullet1.circle.radius = 3;
      const range1 = dateAxis.createSeriesRange(series);
      try {
        // @ts-ignore
        if (state.filters.selectedType === 'predictedMetrics') predictionDate = predictionTill?.city || predictionDate
        // @ts-ignore
        else predictionDate = predictionTill?.zip || predictionDate
      } catch (e) {
        console.error(e)
      }

      range1.date = predictionDate
      range1.endDate = new Date(2029, 4, 1);
      range1.contents.strokeDasharray = '3, 3';

    }
    if (isSetToZoom) {
      // @ts-ignore
      scrollbarX.series.push(series);
      chartRef.current.scrollbarX = scrollbarX;
      chartRef.current.scrollbarX.parent = chartRef.current.bottomAxesContainer;
      chartRef.current.scrollbarX.startGrip.background.states.getKey(
        'hover'
      ).properties.fill = am4core.color('#fff');
      chartRef.current.scrollbarX.endGrip.background.states.getKey(
        'hover'
      ).properties.fill = am4core.color('#fff');
      chartRef.current.scrollbarX.startGrip.background.fill = am4core.color('#F7B047');
      chartRef.current.scrollbarX.endGrip.background.fill = am4core.color('#F7B047');
      chartRef.current.scrollbarX.thumb.background.fill = am4core.color('#171d25');
      let scrollSeries = chartRef.current.scrollbarX.scrollbarChart.series.getIndex(0);
      scrollSeries.stroke = '#000';
      chartRef.current.scrollbarX.background.fill = am4core.color('#fff');
      chartRef.current.scrollbarX.background.fillOpacity = 0.2;
      chartRef.current.scrollbarX.unselectedOverlay.fill = am4core.color('#fff');
      chartRef.current.scrollbarX.unselectedOverlay.fillOpacity = 0.5;
    }

    // Add legend
    chartRef.current.legend = new am4charts.Legend();
    chartRef.current.legend.itemContainers.template.events.on('over', (event: any) => {
      const segments = event.target.dataItem.dataContext.segments;
      segments.each((segment: any) => {

        segment.isHover = true;
      })
    })

    chartRef.current.legend.itemContainers.template.events.on('out', (event: any) => {
      const segments = event.target.dataItem.dataContext.segments;
      segments.each((segment: any) => {
        segment.isHover = false;
      })
    })

    chartRef.current.cursor = new am4charts.XYCursor();
    chartRef.current.cursor.xAxis = dateAxis;

    return () => {
      chartRef.current && chartRef.current.dispose();
    };
  }, [chartData, chartId]);

  return (
    <div className='what-if-chart'>
      <div className='chart-area' id={chartId} ref={chartRef}/>
    </div>
  );
};

export default Chart;